import PulseReport from './PulseReport.container';

export default PulseReport;
